import React, { Component, Fragment } from "react";
import User_menu from "./user-menu";
import "./Header.css";
import { connect } from "react-redux";
import { AlignLeft, MoreHorizontal } from "react-feather";
import Language from "./language";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { change_Lang } from "../../../actions/Helper_action";
import { LogOut } from "../../../actions/Auth_action";
import Instance from "../../../util/Instance";
import setToken from "../../../util/SetToken";
import { Drawer, Modal } from "antd";
import {
  Tenant_View_Contract,
  Tenant_View_takeMoney,
} from "../../../actions_agent/Invoice_action";
import TodoApp from "../../../containers_Agent/TodoList/TodoApp";
import Swal from "sweetalert2";
import { Get_List_Todo } from "../../../actions_agent/Todo_action";
export class Header_Agent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebar: true,
      rightSidebar: true,
      navMenus: false,
      visible: false,
      placement: "left",
      tenants: [],
      tenants_endcontract: [],
      isModalVisible: false,
    };
  }
  showModal = () => {
    const { Get_List_Todo } = this.props;
    this.setState({ isModalVisible: true }, () => Get_List_Todo());
  };
  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };
  componentDidMount() {
    this.GetNotificationEndRentContract();
  }
  GetNotificationEndRentContract = async () => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/endRepotRentContract`, config);
      let tenants_endcontract = res.data.data;
      this.setState({ tenants_endcontract });
    } catch (error) {}
  };
  onDeleteEndContract = (id) => {
    const { change_Lang } = this.props;
    const { GetNotificationDelete } = this;
    return Swal.fire({
      title: change_Lang("Are you sure"),
      html: `<label class="fk">${change_Lang(
        "You won't be able to delete this!"
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: change_Lang("Yes, delete it"),
      cancelButtonText: change_Lang("cancel"),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        GetNotificationDelete(id);
        Swal.fire({
          title: change_Lang("Delete"),
          text: change_Lang("Your work has been successfully completed"),
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
          timer: 1500,
        });
      }
    });
  };
  GetNotificationDelete = async (id) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/deleteNotfication/${id}`, config);
    } catch (error) {}
  };
  toggle() {
    this.setState((prevState) => ({
      navMenus: !prevState.navMenus,
    }));
  }
  showDrawer = () => {
    this.setState({ visible: true });
  };

  onClose = () => {
    this.setState({ visible: false });
  };
  showRightSidebar = () => {
    if (this.state.rightSidebar) {
      this.setState({ rightSidebar: false });
      document.querySelector(".right-sidebar").classList.add("show");
    } else {
      this.setState({ rightSidebar: true });
      document.querySelector(".right-sidebar").classList.remove("show");
    }
  };
  goFull = () => {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };
  steNavMenuClose = () => {
    this.setState({ navMenus: false, sidebar: true }, () => {
      if (this.state.sidebar) {
        this.setState({ sidebar: false });
        document.querySelector(".page-main-header").classList.add("open");
        document.querySelector(".page-sidebar").classList.add("open");
      } else {
        this.setState({ sidebar: true });
        document.querySelector(".page-main-header").classList.remove("open");
        document.querySelector(".page-sidebar").classList.remove("open");
      }
    });
  };
  openCloseSidebar = () => {
    if (this.state.sidebar) {
      this.setState({ sidebar: false });
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    } else {
      this.setState({ sidebar: true });
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    }
  };
  render() {
    const { user, lang } = this.props;
    const { onDeleteEndContract } = this;
    return (
      <Fragment>
        {/* open */}
        <div className="page-main-header ">
          <div className="main-header-right row">
            <div className="main-header-left d-lg-none">
              {isMobile !== true ? (
                <div className="logo-wrapper">
                  <a href="index.html">
                    {localStorage.getItem("GPC_Agent_token") ? (
                      <img
                        className="blur-up lazyloaded"
                        src={`/${user.image}`}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                    <i className="mr-1">Zangin</i>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="mobile-sidebar">
              <div className="media-body text-right switch-sm">
                <label className="switch">
                  <a onClick={this.openCloseSidebar}>
                    <AlignLeft />
                  </a>
                </label>
              </div>
            </div>
            <div
              className="yusifs"
              data-text="Zangin For Best Feature"
              style={{
                margin: "auto",
                marginLeft: `${lang === "en" ? "320px" : ""}`,
                marginRight: `${lang === "en" ? "" : "320px"}`,
              }}
            >
              <Link style={{ color: "#4064d7" }} to="/dashboard">
                Zangin - {this.props.isAuth ? user.branchId.name : ""}
              </Link>
            </div>
            <div className="nav-right col">
              <ul
                className={"nav-menus " + (this.state.navMenus ? "open" : "")}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <div onClick={this.showModal}>
                  <i
                    style={{
                      color: "#4064d7",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                    className="fas fa-tasks mt-3"
                  ></i>
                </div>
                &nbsp;&nbsp;
                <li className="d-flex justify-content-end mt-3">
                  <i
                    className="far fa-bell"
                    onClick={() => {
                      this.showDrawer();
                      this.GetNotificationEndRentContract();
                    }}
                    style={{
                      color: "#4064d7",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        color: "#4064d7",
                        fontSize: "12px",
                        position: "absolute",
                        top: 0,
                      }}
                    >
                      {this.state.tenants_endcontract.length !== 0 ||
                      this.state.tenants.length !== 0
                        ? this.state.tenants_endcontract.length +
                          this.state.tenants.length
                        : ""}
                    </span>
                  </i>
                  <Drawer
                    title="Notifications"
                    placement={this.state.placement}
                    className="fk"
                    closable={false}
                    onClose={this.onClose}
                    open={this.state.visible}
                    width="320px"
                  >
                    {/* end contract */}
                    {this.state.tenants_endcontract.map((el) => {
                      return (
                        <div
                          className="main-header-left  d-lg-block"
                          style={{ borderBottom: "1px solid #f1f3fe" }}
                          key={el._id}
                        >
                          <div className="logo-wrapper justify-content-center mt-1">
                            <div className="row">
                              <div className="col-2">
                                <i
                                  className="fa fa-trash-o"
                                  onClick={() => onDeleteEndContract(el._id)}
                                  style={{
                                    color: "red",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                  }}
                                ></i>
                              </div>
                              <div className="col-7 d-flex justify-content-end">
                                <Link
                                  to={`/Tenant_View_All_Contract/${
                                    el.tenantId && el.tenantId._id
                                  }`}
                                  onClick={() => {
                                    this.onClose();
                                    this.props.Tenant_View_Contract(
                                      el.tenantId && el.tenantId._id
                                    );
                                  }}
                                >
                                  <i
                                    style={{
                                      color: "grey",
                                      fontSize: "14px",
                                    }}
                                  >
                                    تەواوبونی گرێبەست
                                  </i>

                                  <br />
                                  <i
                                    style={{
                                      color: "#000",
                                      fontSize: "14px",
                                    }}
                                    className="d-flex justify-content-end fk form-inline"
                                  >
                                    <span>
                                      {" "}
                                      ({el.tenantId && el.tenantId.secondname})
                                    </span>
                                  </i>
                                </Link>
                              </div>
                              <div className="col-3 d-flex justify-content-start">
                                {" "}
                                <img
                                  className=""
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "100%",
                                  }}
                                  src={`https://e7.pngegg.com/pngimages/613/636/png-clipart-computer-icons-user-profile-male-avatar-avatar-heroes-logo-thumbnail.png`}
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Drawer>
                </li>
                &nbsp;&nbsp;
                {/* <Globe/> */}
                <li className="onhover-dropdown mt-3">
                  <h6 className={`${this.props.lang === "en" ? "" : "fk"}`}>
                    {this.props.lang === "en"
                      ? "English"
                      : this.props.lang === "arb"
                      ? "عربی"
                      : this.props.lang === "krd"
                      ? "کوردی"
                      : ""}
                  </h6>
                  <Language steNavMenuClose={this.steNavMenuClose} />
                </li>
                {isMobile !== true ? (
                  <>
                    <li className="onhover-dropdown mt-3  ">
                      <Link to={"/"}>
                        <h6
                          onClick={() => this.props.LogOut()}
                          className={`${this.props.lang === "en" ? "" : "fk"}`}
                        >
                          {this.props.change_Lang("s_logout")}
                        </h6>
                      </Link>
                    </li>
                  </>
                ) : (
                  ""
                )}
                {isMobile !== true ? "" : <User_menu />}
              </ul>
              <div
                className="d-lg-none mobile-toggle pull-right"
                onClick={() => this.toggle()}
              >
                <MoreHorizontal />
              </div>
            </div>
            <hr
              style={{
                height: "10px",
                background: "red",
                borderBottom: "2px solid #cfa07c",
              }}
            />
          </div>
        </div>
        <Modal
          title={this.props.change_Lang("MY TO DO LIST")}
          footer={false}
          className="fk"
          width={1000}
          open={this.state.isModalVisible}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
        >
          <TodoApp />
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
    isAuth: state.AuthReducer.isAuth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Tenant_View_takeMoney: (id) => dispatch(Tenant_View_takeMoney(id)),
    Tenant_View_Contract: (id) => dispatch(Tenant_View_Contract(id)),
    Get_List_Todo: () => dispatch(Get_List_Todo()),
    LogOut: () => dispatch(LogOut()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header_Agent);
